var map = {
	"./dweb.svg": "a635",
	"./filecoin.svg": "ab5a",
	"./ipfs.svg": "2864",
	"./ipld.svg": "5cac",
	"./libp2p.svg": "2d5d",
	"./multiformats.svg": "867f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3f7a";